// 정식 등급이 되는 순간(시작 등급 지정 · 루키 승급 심사 승인) 가입비 결제 + 카드 등록 전 잠금 — 「레이블리 시작하기」(/start)로 보낸다
// (대표 지시 2026-10-20 · 시안 C 채택: 전면 창 대신 시작하기 단계 화면)
// UserLayout 에 한 번만 마운트(크리에이터 레이아웃 · Admin/Platform 제외). 판정은 서버 tier_grant_payment_gate 하나(useTierGrantGate).
// 보내지 않는 경로: 결제(/billing·/billing/pay·/billing/success·/billing/fail) · 문의(/support) · 약관(/policies) · 환영 여정(/welcome).
// 대리 접속(어드민 상단 「다른 사용자 이메일」)도 회원과 똑같이 보낸다 — 2026-10-20 대표가 대리 접속으로 김도헌 님 계정을 보고
//   「결제 화면이 안 뜨고 모든 버튼이 눌린다」고 했다(처음엔 WelcomeRedirect 처럼 대리 접속을 빼 두었다). /start 위 「돌아가기」로 빠져나온다.
//   어드민 정산 미러(AdminUserSettlementView 의 iframe)만 보내지 않는다 — 그 화면은 정산을 보려고 연 것이다.
// 서버도 같은 사람의 작품 신청·다운로드를 막는다(can_use_works) — 이 이동은 「다른 버튼을 못 누르게」 하는 겉면이다.
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useTierGrantGate from "../../hooks/useTierGrantGate";
import { isTierGrantGateExempt, START_PATH } from "../../lib/tierGrantGate";

function inAdminMirrorFrame() {
  try {
    return typeof window !== "undefined" && window.self !== window.top;
  } catch (e) {
    return true;   // 다른 출처의 부모 창 — 미러로 본다
  }
}

export default function SignupLockRedirect({ email }) {
  const { gate } = useTierGrantGate(email);
  const { pathname } = useLocation();
  if (!email || !gate?.gated || inAdminMirrorFrame() || isTierGrantGateExempt(pathname)) return null;
  return <Navigate to={START_PATH} replace />;
}
